import { SerializedError } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

export const parseError: (error: AxiosError | SerializedError | Error | string) => SerializedError = error => {
  if (typeof error === 'object' && error !== null) {
    if (error instanceof AxiosError) {
      const { response, message } = error;

      if (response?.data?.detail) {
        return {
          code: `${response.status}`,
          message: response.data.detail,
          name: 'DataError',
        };
      }
      if (response?.data?.non_field_errors) {
        return {
          code: `${response.status}`,
          message: Array.isArray(response.data.non_field_errors)
            ? response.data.non_field_errors[0]
            : response.data.non_field_errors,
          name: 'NonFieldsError',
        };
      }

      if (response?.data?.message) {
        return {
          code: `${response.status}`,
          message: response.data.message,
          name: 'ServerError',
        };
      }

      if (response?.data && typeof response.data === 'object') {
        const errorMessages = Object.values(response.data)
          .flat()
          .filter((item): item is string => typeof item === 'string')
          .join('; ');

        if (errorMessages) {
          return {
            code: `${response.status || 'Unknown'}`,
            message: errorMessages,
            name: 'GenericError',
          };
        }
      }

      if (message) {
        return {
          code: `${response.status}`,
          message,
          name: 'NetworkError',
        };
      }

      return {
        message: message || 'Unknown Axios error occurred',
        name: 'AxiosError',
      };
    }

    if (error instanceof Error) {
      return {
        message: error.message,
        name: 'RuntimeError',
      };
    }

    if ('name' in error && 'message' in error) {
      return error;
    }
  }

  if (typeof error === 'string') {
    return {
      message: error,
      name: 'Error',
    };
  }

  return {
    message: 'An unknown error occurred',
    name: 'UnknownError',
  };
};
